/* Product 21/24 live winning behavior, native theme implementation. */
(() => {
  if (!document.documentElement.dataset.cgkWinners || window.cgkProductWinners) return;
  window.cgkProductWinners = true;
  const mobile = matchMedia('(max-width: 767px)');
  const productContainer = document.querySelector('product-info .container');
  function placeAccordion() {
    const accordion = document.querySelector('[data-cgk-accordion]');
    const anchor = document.querySelector('[data-cgk-accordion-anchor]');
    const features = document.querySelector('.ACC_CGK_Product_21-fc');
    if (!accordion || !anchor || !features || !productContainer) return;
    // Keep the winner immediately after the product container, as in the
    // agency code, even when another test inserts sections there later.
    if (mobile.matches) {
      if (productContainer.nextElementSibling !== accordion) productContainer.after(accordion);
      if (accordion.nextElementSibling !== features) accordion.after(features);
    } else {
      if (anchor.nextElementSibling !== accordion) anchor.after(accordion);
      if (productContainer.nextElementSibling !== features) productContainer.after(features);
    }
  }
  placeAccordion();
  mobile.addEventListener('change', placeAccordion);
  if (productContainer?.parentElement) {
    new MutationObserver(placeAccordion).observe(productContainer.parentElement, { childList: true });
  }
  document.addEventListener('click', (event) => {
    const header = event.target.closest('.ACC_CGK_Product_21-accordion__header');
    if (!header) return;
    const item = header.closest('.ACC_CGK_Product_21-accordion__item');
    const open = !item.classList.contains('is-open');
    for (const other of item.parentElement.children) {
      const active = other === item && open;
      other.classList.toggle('is-open', active);
      other.querySelector('button').setAttribute('aria-expanded', String(active));
      other.querySelector('[role="region"]').inert = !active;
    }
  });
  const definitions = {
  ACC_CGK_Product_24: {
    stories: [
      {
        id: 1,
        name: "Samilahstyles",
        image: "https://cdn.shopify.com/s/files/1/1192/4826/files/ACC_CGK_Product_24_1.webp?v=1784045948",
        video: "https://cdn.shopify.com/videos/c/o/v/d16531c7a6644da8846cf7fa23560548.mp4" },
      {
        id: 2,
        name: "Tay.sammyd",
        image: "https://cdn.shopify.com/s/files/1/1192/4826/files/ACC_CGK_Product_24_2.webp?v=1784045948",
        video: "https://cdn.shopify.com/videos/c/o/v/41ba9dac90ad44b59c83a9e76f22b428.mp4" },
      {
        id: 3,
        name: "Julianna_claire",
        image: "https://cdn.shopify.com/s/files/1/1192/4826/files/ACC_CGK_Product_24_3.webp?v=1784045951",
        video: "https://cdn.shopify.com/videos/c/o/v/dc43a1f90d6e4085b116a843c31562d1.mp4" },
      {
        id: 4,
        name: "Gottaknow mara",
        image: "https://cdn.shopify.com/s/files/1/1192/4826/files/ACC_CGK_Product_24_4.webp?v=1784045948",
        video: "https://cdn.shopify.com/videos/c/o/v/d2477b50af88449580a66f2d5092a31c.mp4" },
      { id: 5,
        name: "Natalie T.",
        image: "https://cdn.shopify.com/s/files/1/1192/4826/files/ACC_CGK_Product_24_5.webp?v=1784045949",
        video: "https://cdn.shopify.com/videos/c/o/v/1fbb00b521474c89a4f0480c814c4b59.mp4" },
      {
        id: 6,
        name: "Destinydelisio",
        image: "https://cdn.shopify.com/s/files/1/1192/4826/files/ACC_CGK_Product_24_6.webp?v=1784045951",
        video: "https://cdn.shopify.com/videos/c/o/v/1c8bfac946b04155bb9491072b08d5ed.mp4" }
    ],
    storySwiper: null,
    videoSwiper: null,
    currentVideo: null,
    videoItems: [],
    eventsBound: false,
    loadSwiper(callback) {
      if (typeof window.Swiper !== 'undefined') callback();
    },
    createStoryHTML() {
      const $this = this;
      const tn = this.__testName;
      if (!document.querySelector(`.${tn}-story-section`)) {
        const storyHTML = `
          <section class="${tn}-story-section">
            <div class="${tn}-story-slider swiper">
              <div class="swiper-wrapper"></div>
            </div>
          </section>
        `;
        $this.runAt(".product__info .buy-buttons__wrapper", ([container]) => {
          container.insertAdjacentHTML("afterend", storyHTML);
        });
      }
      if (!document.querySelector(`.${tn}-popup`)) {
        // appended directly to <body> so position:fixed covers the whole
        // viewport instead of being clipped by a transformed/overflow parent
        const popupHTML = `
          <div class="${tn}-popup" role="dialog" aria-modal="true" aria-label="Customer video stories" tabindex="-1">
            <div class="${tn}-popup-overlay"></div>
            <div class="${tn}-popup-wrapper">
              <button class="${tn}-popup-close" aria-label="Close">✕</button>
              <button class="${tn}-nav ${tn}-prev" aria-label="Previous">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M8.72266 1.94434L3.6671 6.99989L8.72266 12.0554" stroke="#DADADA" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <button class="${tn}-nav ${tn}-next" aria-label="Next">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M5.27734 1.94434L10.3329 6.99989L5.27734 12.0554" stroke="#DADADA" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div class="${tn}-video-slider swiper">
                <div class="swiper-wrapper"></div>
              </div>
            </div>
          </div>
        `;
        document.body.insertAdjacentHTML("beforeend", popupHTML);
      }
    },
    renderStories() {
      const $this = this;
      const tn = this.__testName;
      const wrapper = document.querySelector(`.${tn}-story-slider .swiper-wrapper`);
      if (!wrapper || wrapper.children.length) return;
      $this.stories.forEach((story, index) => {
        wrapper.insertAdjacentHTML("beforeend", `
          <div class="swiper-slide">
            <div class="${tn}-story-item" data-index="${index}">
              <div class="${tn}-story-image">
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                  <rect x="1.5" y="1.5" width="77" height="77" rx="38.5" stroke="url(#paint0_linear_1434_18)" stroke-width="3"/>
                  <defs>
                    <linearGradient id="paint0_linear_1434_18" x1="58.49" y1="-9.49023" x2="6.48999" y2="70.0098" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#FF01E1"/>
                      <stop offset="0.403846" stop-color="#FF0130"/>
                      <stop offset="1" stop-color="#FFE100"/>
                    </linearGradient>
                  </defs>
                </svg>
                <img src="${story.image}" alt="${story.name}">
              </div>
              <p class="${tn}-story-name">${story.name}</p>
            </div>
          </div>
        `);
      });
    },
    renderVideos() {
      const $this = this;
      const tn = this.__testName;
      const wrapper = document.querySelector(`.${tn}-video-slider .swiper-wrapper`);
      if (!wrapper || wrapper.children.length) return;
      $this.stories.forEach((story, index) => {
        wrapper.insertAdjacentHTML("beforeend", `
          <div class="swiper-slide">
            <div class="${tn}-video-item" data-index="${index}">
              <div class="${tn}-video-progress">
                <div class="${tn}-video-progress-bar"></div>
              </div>
              <div class="${tn}-video-header">
                <div class="${tn}-video-avatar">
                  <img src="${story.image}" alt="${story.name}">
                </div>
                <div class="${tn}-video-user">
                  <p class="${tn}-video-username">${story.name}</p>
                  <p class="${tn}-video-verified">Verified Customer</p>
                </div>
              </div>
              <video class="${tn}-video" preload="metadata" playsinline
                webkit-playsinline
                poster="${story.image}" > <source src="${story.video}" type="video/mp4">
              </video>
              <button class="${tn}-video-play" aria-label="Play video">▶</button>
              <button class="${tn}-video-pause hide" aria-label="Pause video"><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
              <rect x="24.2324" y="13.2544" width="4.69922" height="17.4911" fill="white"></rect>
              <rect x="15.0684" y="13.2544" width="4.69922" height="17.4911" fill="white"></rect>
              </svg></button>
            </div>
          </div>
        `);
      });
      // handleSlideChange to avoid re-querying the DOM on every slide change
      $this.videoItems = Array.from(wrapper.querySelectorAll(`.${tn}-video-item`));
      // delegated listener in bindEvents — attach it directly per video.
      $this.videoItems.forEach((item) => {
        item.querySelector("video")?.addEventListener("ended", () => $this.toggleButtons(item, false));
      });
    },

    // centeredSlides gives the active video the peek/standby effect on the
    // sides, like Instagram stories
    initVideoSwiper() {
      const $this = this;
      const tn = this.__testName;
      if ($this.videoSwiper) $this.videoSwiper.destroy(true, true);
      $this.videoSwiper = new Swiper(`.${tn}-video-slider`, {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 10,
        loop: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 12 },
          768: { slidesPerView: 3, spaceBetween: 16 }
        },
        navigation: {
          nextEl: `.${tn}-next`,
          prevEl: `.${tn}-prev`
        },
        on: {
           slideChangeTransitionEnd(swiper) {
            $this.handleSlideChange(swiper.realIndex);
          }
        }
      });
    },

    openPopup(index) {
      const $this = this;
      const tn = this.__testName;
      const popup = document.querySelector(`.${tn}-popup`);
      if (!popup) return;
      $this.returnFocus = document.activeElement;
      $this.renderVideos();
      $this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      popup.classList.add("active");
      popup.querySelector(`.${tn}-popup-close`).focus();
      // until renderStories/initStorySwiper have already run after loadSwiper
      if (!$this.videoSwiper) $this.initVideoSwiper();
      // the popup is laid out, recalc, then navigate.
      requestAnimationFrame(() => {
        if (!popup.classList.contains('active')) return;
        $this.videoSwiper.update();
        // slideToLoop (not slideTo) — loop-mode-aware navigation
        $this.videoSwiper.slideToLoop(index, 0);
        $this.handleSlideChange(index);
      });
    },

    closePopup() {
      const $this = this;
      const tn = this.__testName;
      const popup = document.querySelector(`.${tn}-popup`);
      if (popup) popup.classList.remove("active");
      // reset every video so the next open always starts from the beginning
      document.querySelectorAll(`.${tn}-video`).forEach((video) => $this.resetVideo(video));
      $this.currentVideo = null;
      document.body.style.overflow = $this.previousOverflow || '';
      $this.returnFocus?.focus();
    },

    handleSlideChange(index) {
      const $this = this;
      if (!document.querySelector('.ACC_CGK_Product_24-popup.active')) return;
      $this.videoItems.forEach((item) => {
        const video = item.querySelector("video");
        if (Number(item.dataset.index) !== index) $this.resetVideo(video);
      });
      const activeItem = $this.videoItems.find((item) => Number(item.dataset.index) === index);
      if (!activeItem) return;
      $this.currentVideo = activeItem.querySelector("video");
      $this.resetVideo($this.currentVideo);
      $this.playVideo();
    },

    playVideo() {
      const $this = this;
      const tn = this.__testName;
      if (!$this.currentVideo || !document.querySelector(`.${tn}-popup.active`)) return;
      const video = $this.currentVideo;
      const playPromise = video.play();
      if (playPromise !== undefined) playPromise.catch(() => {
        // An earlier play request can reject after navigation has started
        // another video, or after the same video has successfully resumed.
        if (video === $this.currentVideo && video.paused) {
          $this.toggleButtons(video.closest(`.${tn}-video-item`), false);
        }
      });
      $this.toggleButtons(video.closest(`.${tn}-video-item`), true);
      requestAnimationFrame(() => $this.updateProgressBar(video));
    },

    updateProgressBar(video) {
      const $this = this;
      const tn = this.__testName;
      if (!video || video !== $this.currentVideo || video.paused || video.ended) return;
      const bar = video.closest(`.${tn}-video-item`)?.querySelector(`.${tn}-video-progress-bar`);
      if (bar && video.duration) {
        bar.style.width = (video.currentTime / video.duration * 100) + "%";
      }
      requestAnimationFrame(() => $this.updateProgressBar(video));
    },

    pauseVideo() {
      const $this = this;
      const tn = this.__testName;
      if (!$this.currentVideo) return;
      $this.currentVideo.pause();
      $this.toggleButtons($this.currentVideo.closest(`.${tn}-video-item`), false);
    },

    resetVideo(video) {
      const tn = this.__testName;
      if (!video) return;
      video.pause();
      video.currentTime = 0;
      this.toggleButtons(video.closest(`.${tn}-video-item`), false);
      const bar = video.closest(`.${tn}-video-item`)?.querySelector(`.${tn}-video-progress-bar`);
      if (bar) bar.style.width = "0%";
    },

    toggleButtons(item, isPlaying) {
      const tn = this.__testName;
      if (!item) return;
      item.querySelector(`.${tn}-video-play`)?.classList.toggle("hide", isPlaying);
      item.querySelector(`.${tn}-video-pause`)?.classList.toggle("hide", !isPlaying);
    },

    bindEvents() {
      const $this = this;
      const tn = this.__testName;
      if ($this.eventsBound) return;
      $this.eventsBound = true;
      document.addEventListener("click", (e) => {
        const story = e.target.closest(`.${tn}-story-item`);
        if (story) return $this.openPopup(Number(story.dataset.index));
        if (e.target.closest(`.${tn}-popup-close`)) return $this.closePopup();
        if (e.target.classList.contains(`${tn}-popup-overlay`)) return $this.closePopup();
        if (e.target.closest(`.${tn}-video-play`)) return $this.playVideo();
        if (e.target.closest(`.${tn}-video-pause`)) return $this.pauseVideo();
        // click anywhere inside the popup wrapper but outside the video-slider
        // (and outside the nav buttons, which handle their own slide change) closes the popup
        const insideWrapper = e.target.closest(`.${tn}-popup-wrapper`);
        const insideVideoSlider = e.target.closest(`.${tn}-video-slider`);
        const insideNav = e.target.closest(`.${tn}-nav`);
        if (insideWrapper && !insideVideoSlider && !insideNav) return $this.closePopup();
      });
    },
    init() {
      const $this = this;
      $this.runAt(".product__info .buy-buttons__wrapper .buy-buttons__button product-form", () => {
        $this.loadSwiper(() => {
          $this.createStoryHTML();
          $this.renderStories();

          $this.bindEvents();
        });
      });
    },
  },
};
  const stories = definitions.ACC_CGK_Product_24;
  stories.__testName = 'ACC_CGK_Product_24';
  stories.runAt = (selector, callback) => {
    const elements = [...document.querySelectorAll(selector)];
    if (elements.length) callback(elements);
  };
  stories.init();
  document.addEventListener('keydown', (event) => {
    const popup = document.querySelector('.ACC_CGK_Product_24-popup.active');
    if (!popup) return;
    if (event.key === 'Escape') { event.preventDefault(); stories.closePopup(); }
    if (event.key === 'ArrowRight') { event.preventDefault(); stories.videoSwiper?.slideNext(); }
    if (event.key === 'ArrowLeft') { event.preventDefault(); stories.videoSwiper?.slidePrev(); }
    if (event.key === 'Tab') {
      const controls = [...popup.querySelectorAll('button')].filter(el => el.getClientRects().length && !el.closest('.swiper-slide:not(.swiper-slide-active)'));
      const index = controls.indexOf(document.activeElement);
      if (event.shiftKey && index <= 0) { event.preventDefault(); controls.at(-1)?.focus(); }
      else if (!event.shiftKey && (index === controls.length - 1 || index < 0)) { event.preventDefault(); controls[0]?.focus(); }
    }
  });
})();
